import { render, staticRenderFns } from "./audioLog.vue?vue&type=template&id=4d887901&scoped=true&"
import script from "./audioLog.vue?vue&type=script&lang=js&"
export * from "./audioLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d887901",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d887901')) {
      api.createRecord('4d887901', component.options)
    } else {
      api.reload('4d887901', component.options)
    }
    module.hot.accept("./audioLog.vue?vue&type=template&id=4d887901&scoped=true&", function () {
      api.rerender('4d887901', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chatLog/audioLog.vue"
export default component.exports